export default __webpack_public_path__ + "static/media/vaccinated_img2.9e1a7e5c.png";